'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTracking = require('react-tracking');

var _reactTracking2 = _interopRequireDefault(_reactTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//Wrap this component around any element we want to track
var TrackClick = function (_React$PureComponent) {
  _inherits(TrackClick, _React$PureComponent);

  function TrackClick() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TrackClick);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TrackClick.__proto__ || Object.getPrototypeOf(TrackClick)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickHOF = function (childOnClickHandler) {
      return function (event) {
        // We want to fire these click events without taking any more time, so we set this up as an async function.
        new Promise(function (resolve, reject) {
          if (_this.props.omtag && _this.props.tracking.trackEvent) {
            _this.props.tracking.trackEvent({ action: 'click', omtag: _this.props.omtag });
          } else {
            console.warn('No omtag provided');
          }
          resolve(true);
        }).catch(function (error) {
          console.log('error: ' + error);
        });

        if (childOnClickHandler) {
          childOnClickHandler(event);
        }
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TrackClick, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var onClick = children.props.onClick;

      var props = {
        omtag: this.props.omtag,
        onClick: this.handleClickHOF(onClick)
      };
      return _react2.default.cloneElement(children, props);
    }
  }]);

  return TrackClick;
}(_react2.default.PureComponent);

TrackClick.propTypes = {
  omtag: _propTypes2.default.string.isRequired
};

exports.default = (0, _reactTracking2.default)()(TrackClick);


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/TrackClick.js
// module id = 984
// module chunks = 48 49 50